/* eslint-disable no-lone-blocks */
/* eslint-disable default-case */
import { App, BarraAggiungiEvento, ImgRandomEventi, NavbarNotAuth, SliderEventi, SliderCittà, Slider, DivBottom } from './components'
import { useEffect, useState } from 'react'
import axios from 'axios'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { NavbarBottomAdmin, NavbarTopAdmin } from '../admin/components'

function CosaFare() {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const bannerCorrente = searchParams.get('banner')
    const [eventi, setEventi] = useState([])

    const logged = localStorage.getItem('logged')
    let colorTdBody, mese
    let arrIndexMesi = []//contiene tutti gli index (01,03,05....) e forniscono l'ID ('mese'+index) al div dove viene iniettato il mese con eventi presenti
    const today = new Date(); const todayForCompare = new Date().toISOString().split('T')[0]
    today.setDate(today.getDate() - 1) //tolgo un giorno alla data odierna
    const tomorrow = new Date(today).toISOString()//valorizzo tomorrow con la data di domani
    const [fotoDaScegliere, setFotoDaScegliere] = useState()

    function eventoDetails(id) {
        navigate(`/eventiDetails/${id}`)
    }
    useEffect(() => {
        console.log('bannerCorrente:', bannerCorrente)
        if (bannerCorrente) {//cosa fare quando clicco previous page
            document.body.style.overflow = 'hidden'
        } else { document.body.style.overflow = '' }
    }, [bannerCorrente])

    useEffect(() => {
        const eventGet = async () => {
            try {
                let response = await axios.get('/getEventi/dataInizio')
                const eventiSenzaIeri = response.data.toReversed().filter(x => !(x.dataFine < tomorrow))
                eventiSenzaIeri.forEach(element => {
                    if (element.img) element.img = element.img.split(',')//da stringa ad array
                })
                setEventi(eventiSenzaIeri
                    .filter(item => (item.accettazione !== 'rejection') && (item.accettazione !== 'false'))
                )
            } catch (err) { console.log(err) }
        }; eventGet()

        const isRefresh = window.performance //intercetto il ricaricamneto della pagina (F5)
            ?.getEntriesByType('navigation')
            ?.[0].type === 'reload'
        if (isRefresh && searchParams.has('banner')) {//rimuovo 'banner' quando ricarico la pagina
            searchParams.delete('banner')
            setSearchParams(searchParams, { replace: true })
        }
    }, [])

    useEffect(() => {
        if (eventi.length > 0) {//CREAZIONE MESE IN EVENTI IN ITALIA
            eventi
                .forEach((evento, index) => {
                    if (evento.dataInizio.substr(0, 7) !== mese) {//es. 2025-01-01 estrapolo 2025-01
                        arrIndexMesi.push(index)
                        const dom = document.getElementById(`mese${index}`)
                        switch (evento.dataInizio.substr(0, 7)) {//inietto in dom il mese e l'anno
                            case `2026-09`: { dom.innerHTML = `Settembre ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2026-10`: { dom.innerHTML = `Ottobre ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2026-11`: { dom.innerHTML = `Novembre ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2026-12`: { dom.innerHTML = `Dicembre ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2027-01`: { dom.innerHTML = `Gennaio ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2027-02`: { dom.innerHTML = `Febbraio ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2027-03`: { dom.innerHTML = `Marzo ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2027-04`: { dom.innerHTML = `Aprile ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2027-05`: { dom.innerHTML = `Maggio ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2027-06`: { dom.innerHTML = `Giugno ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2027-07`: { dom.innerHTML = `Luglio ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2027-08`: { dom.innerHTML = `Agosto ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2027-09`: { dom.innerHTML = `Settembre ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2027-10`: { dom.innerHTML = `Ottobre ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2027-11`: { dom.innerHTML = `Novembre ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                            case `2027-12`: { dom.innerHTML = `Dicembre ${evento.dataInizio.substr(0, 4)}`; dom.style.zIndex = '-100' }; break
                        }
                        mese = evento.dataInizio.substr(0, 7)
                        dom.style.display = 'block'
                    }
                })
        }
    }, [eventi])
    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <ImgRandomEventi onDataSubmit={(e) => { setFotoDaScegliere(e) }} />
        <br />
        <div style={{ marginTop: '4rem' }}>
            <p style={{ marginLeft: '1rem' }}>\<b>Cosa Fare</b></p>
            <App />
            <BarraAggiungiEvento />
            {!logged && <div><SliderEventi /><Slider /> </div>}
            <div style={{ marginBottom: '7rem' }}>
                <div style={{ backgroundColor: 'ghostwhite', borderTop: '1px solid lightgrey', borderBottom: '1px solid lightgrey', marginTop: '2em' }}>
                    <h5 className='mt-5' style={{ textAlign: 'center', fontFamily: 'sans-serif' }}>
                        <b>EVENTI IN EVIDENZA</b>
                    </h5><br />

                    <div style={{ overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden' }}>
                        {eventi && eventi.filter(item => (item.vetrina === 'inEvidenza'))
                            .reverse()
                            .map((evento, index) => {
                                const itemScelto = fotoDaScegliere.find(item => item.tipologia === evento.tipologia)
                                let fotoScelta
                                if (itemScelto && !evento.img) {
                                    const arrayFoto = itemScelto.foto; // Prende l'array di foto corretto
                                    const indiceCasuale = Math.floor(Math.random() * arrayFoto.length)
                                    fotoScelta = arrayFoto[indiceCasuale]
                                }
                                return (
                                    <div key={index} className="scrollmenu_article" id={index + 'card'}>
                                        <Link to={`/eventiDetails/${evento.id}`} state={{ fotoScelta: fotoScelta }} style={{ textDecoration: 'none', color: 'black' }}>
                                            <div>
                                                {evento.img[0] ?
                                                    <img src={`https://leuro-bucket.s3.amazonaws.com/${evento.img[0]}`} width={282} height={230}
                                                        style={{ objectFit: 'cover' }} alt='' />
                                                    : //foto scelta a caso da AWS
                                                    fotoScelta ? <img src={`https://leuro-bucket.s3.amazonaws.com/imgRandomEventi/${fotoScelta}`} width={282} height={230} className='rounded'
                                                        style={{ objectFit: 'cover' }} alt='' />
                                                        :
                                                        <img src={`https://leuro-bucket.s3.amazonaws.com/evento_senza_foto.jpg`} width={282} height={230} alt='' />
                                                }
                                                <p style={{
                                                    margin: '3px 0px 0px 3px', backgroundColor: 'beige', borderBottom: '1px solid silver',
                                                    textAlign: 'center', fontWeight: '600', fontSize: '14px'
                                                }}>{evento.titolo.length > 38 ? <span>{evento.titolo.slice(0, 37)}...</span> : evento.titolo
                                                    }
                                                </p>
                                                <p style={{ margin: '10px 3px' }}>{evento.città} ({evento.provincia})</p>
                                                <p style={{ margin: '0px 3px' }}>{evento.dataInizio.split("-").reverse().join("-")}
                                                    {evento.dataFine !== evento.dataInizio &&
                                                        <span> ⇛ {evento.dataFine.split("-").reverse().join("-")}</span>
                                                    }
                                                </p>
                                                {todayForCompare >= evento.dataInizio === true && todayForCompare <= evento.dataFine === true &&//check se evento è in svolgimento
                                                    <p className='ms-1 text-success float-start'>
                                                        <b>in corso</b>
                                                    </p>
                                                }
                                                <span style={{
                                                    float: 'right', backgroundColor: 'maroon', borderRadius: '5px', padding: '3px',
                                                    color: 'azure', opacity: '.7', marginRight: '3px'
                                                }}>
                                                    {evento.tipologia}
                                                </span>
                                            </div>
                                        </Link>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div style={{ height: '2em' }}></div>
                </div>
                <div style={{ margin: '3rem 0 0 0' }}>
                    <h2 className='text-center'>🏁 EVENTI IN ITALIA </h2><br />
                    <div style={{ textAlign: 'center', border: '1px solid lightskyblue', width: '95%', margin: 'auto', padding: '1rem 3px', borderBottom: 'none', fontFamily: 'sans-serif' }}>
                        scorri a destra ⇉
                    </div>

                    {/* ---------------- CREAZIONE DI OVERFLOW AUTO CHE VISUALIZZA IL RIASSUNTO DEGLI EVENTI -------------- */}
                    <div style={{
                        border: '2px solid lightskyblue', width: '95%', margin: 'auto', overflowX: 'scroll', overflowY: 'hidden', paddingBottom: '20px', borderTop: 'none'
                    }}>
                        {eventi && eventi
                            .map((evento, index) => {
                                const eventInAction = todayForCompare >= evento.dataInizio && todayForCompare <= evento.dataFine//check se evento è in svolgimento
                                evento.dataFine < tomorrow ? colorTdBody = 'darkgray' :
                                    eventInAction === true ? colorTdBody = '600' : colorTdBody = '500'
                                return (
                                    <span key={evento.id}>
                                        <div id={"mese" + index}
                                            style={{
                                                position: 'sticky', top: '0', display: 'none', padding: '5px 15px', fontWeight: '700', fontFamily: 'italic',
                                                color: 'navy', backgroundColor: 'white'
                                            }}
                                        >
                                            {/* QUI VIENE INIETTATO IL MESE E L'ANNO */}
                                        </div>

                                        <div className='divGridCosaFare' onClick={() => { eventoDetails(evento.id) }}
                                            style={{ fontWeight: colorTdBody }}>
                                            <div>{evento.tipologia}</div>
                                            <div>{evento.provincia}</div>
                                            <div>
                                                {eventInAction === true ? <span className='text-success'><i>in corso</i></span> :
                                                    evento.dataInizio.split("-").reverse().join("-")
                                                } ⇾</div>
                                            <div>{evento.dataFine.split("-").reverse().join("-")}</div>
                                            <div>{evento.comune.substring(0, 25)}
                                                {evento.comune.length > 25 && <span>...</span>}
                                            </div>
                                            <div>{eventInAction && <span>✅</span>}{evento.titolo}</div>
                                        </div>
                                        {eventi.length !== index + 1 && <hr className='hrCosaFare' />
                                        }
                                    </span>
                                )
                            })}
                    </div>
                </div>
            </div>
            <SliderCittà />
            <DivBottom />
        </div >
    </>)
}
export default CosaFare